<template>
  <div>
    <div class="pa-1">
      <v-card>
        <v-card-title>{{ $t('Messages by Time') }}</v-card-title>

        <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
        <template v-if="activeuserbytimeSeries">
          <apexchart
            ref="activeuserbytime"
            type="area"
            height="350"
            :options="activeuserbytime"
            :series="activeuserbytimeSeries"
          ></apexchart>
        </template>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

import moment from 'moment'

import VueApexCharts from 'vue-apexcharts'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

import StatCard from './StatCard'
import DashboardGraphLoading from './DashboardGraphLoading'
export default {
  props: ['loading', 'selectedDate', 'filter'],
  data: function() {
    return {
      activeuserbytimeSeries: undefined,

      activeuserbytime: {
        starttime: 0,
        endtime: 24,
        chart: {
          height: 350,
          type: 'area',
          zoom: {
            enabled: true
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        xaxis: {
          categories: [
            '0:00',
            '1:00',
            '2:00',
            '3:00',
            '4:00',
            '5:00',
            '6:00',
            '7:00',
            '8:00',
            '9:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
            '17:00',
            '18:00',
            '19:00',
            '20:00',
            '21:00',
            '22:00',
            '23:00'
          ]
        },
        yaxis: {
          show: true,
          title: {
            text: this.$t('Message')
          }
        },
        tooltip: {
          x: {
            format: 'HH:mm'
          }
        }
      }
    }
  },
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  mounted: function() {
    if (this.selectedBot.status) this.getActiveUserByTime()
    else {
      this.$nextTick().then(() => {
        this.activeuserbytimeSeries = [
          {
            name: this.$t('Message'),
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
        this.$emit('onLoaded', { loading: false, data: null })
      })
    }
  },
  methods: {
    getActiveUserByTime: function() {
      let vm = this
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'),
        time_0: vm.activeuserbytime.starttime,
        time_1: vm.activeuserbytime.endtime,
        app: this.filter
      }
      vm.$emit('onLoaded', { loading: true, data: null })
      api.getDashboardActiveUserByTime(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$emit('onLoaded', { loading: false, data: null })
          return
        }
        let data = []
        let label = []
        let max = 0
        if (response.data.length > 0) {
          $.each(response.data[0], function(index, val) {
            label.push(index.split('_')[1] + ':00')
            // data.push({ x: moment('01/01/2020 ' + index.split('_')[1] + ':00 GMT').format(), y: parseInt(val) })
            data.push(parseInt(val))

            if (max < parseInt(val)) {
              max = parseInt(val)
            }
          })
          vm.activeuserbytime.raw = data
        }

        vm.activeuserbytimeSeries = [{ name: vm.$t('Message'), data: data }]

        // vm.activeuserbytime.xaxis.categories = label;
        vm.$nextTick(function() {
          if (vm.$refs.activeuserbytime) {
            vm.$refs.activeuserbytime.updateOptions({
              yaxis: {
                max: max + 5
              },
              xaxis: {
                categories: label,
                labels: {
                  show: true
                }
              }
            })
          }
          vm.$emit('onLoaded', { loading: false, data: vm.activeuserbytimeSeries })
        })
      })
    }
  },
  watch: {
    loading: function() {},
    selectedDate: {
      handler: function(newValue) {
        this.getActiveUserByTime()
      },
      deep: true
    },
    filter: function() {
      this.getActiveUserByTime()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/ActiveUserByTime.vue